export default function ReferralMsg({ onClose }) {
  return (
    <>
      <div className="referral-message-modal">
        <div className="referral-message-modal-container">
          <p>Copied successfully</p>
          <button onClick={onClose}>Close</button>
        </div>
      </div>
    </>
  )
}
